import React from 'react'
import {Route} from "react-router-dom";
import {connect} from "react-redux";

function PrivateRoute({isAuthorize, ...rest}) {
    if(isAuthorize){
        return (
            <Route {...rest} />
        )
    }else{
         window.location.assign('/login')
    }

}

const MapStateToProps = (state) => {
    return {
        isAuthorize: state.handleAuth.isAuthorize,
    }
};
export default connect(MapStateToProps)(PrivateRoute)
